let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("djU0u")).then(() => parcelRequire('3qkos'));